export default __webpack_public_path__ + "static/media/women1.63d06d4f.jpg";